import React from 'react'
import { Box, Paper } from '@mui/material'
import { Table } from 'react-bootstrap'
import SearchInput from '../../components/SearchInput'
import { STATUS_CANCELLED } from '../../constants/chargeConstants'
import {
  SETTLEMENT_CANCELLED_DOCUMENTS_EMPTY_STATE,
  SETTLEMENT_CANCELLED_DOCUMENTS_SEARCH_CREDITO,
  SETTLEMENT_CANCELLED_DOCUMENTS_SEARCH_FACTURA,
  SETTLEMENT_CANCELLED_DOCUMENTS_SEARCH_NOTA_CREDITO,
  SETTLEMENT_CANCELLED_DOCUMENTS_SEARCH_PLACEHOLDER,
  SETTLEMENT_CANCELLED_DOCUMENTS_STATUS_LABEL,
  SETTLEMENT_CANCELLED_DOCUMENTS_TABLE_HEADERS,
  SETTLEMENT_CANCELLED_DOCUMENTS_TITLE
} from '../../constants/settlementDetailsConstants'
import SettlementDetailContextHeader from '../../components/SettlementDetailContextHeader'
import { getTimestampFromDateTime } from '../../helpers/formatDate'
import { formatMoney, parseDocumentType } from '../../helpers/utils'
import { sortNewestFirst } from '../helpers/detailsHelpers'

export default function SettlementCancelledDocumentsTab({ settlement = null, actions = null }) {
  const [search, setSearch] = React.useState('')
  const details = React.useMemo(() => settlement?.details || [], [settlement])

  const rows = React.useMemo(() => {
    const normalizedSearch = search.trim().toLowerCase()

    return sortNewestFirst(details)
      .filter((charge) => charge.charge_status === STATUS_CANCELLED)
      .filter((detail) => {
        if (!normalizedSearch) return true
        const queryType =
          normalizedSearch === SETTLEMENT_CANCELLED_DOCUMENTS_SEARCH_FACTURA
            ? 'F'
            : normalizedSearch.includes(SETTLEMENT_CANCELLED_DOCUMENTS_SEARCH_CREDITO) ||
                normalizedSearch === SETTLEMENT_CANCELLED_DOCUMENTS_SEARCH_NOTA_CREDITO
              ? 'C'
              : normalizedSearch

        const documentType = String(detail.child_document_type || '').toLowerCase()

        return (
          String(detail.child_document_reference || '')
            .toLowerCase()
            .includes(normalizedSearch) || documentType === String(queryType).toLowerCase()
        )
      })
  }, [details, search])

  const handleSearchChange = (event) => {
    setSearch(event.target.value)
  }

  const handleClearSearch = () => {
    setSearch('')
  }

  const handleSearchEnter = (event) => {
    if (event.key !== 'Enter') return
    event.preventDefault()
  }

  return (
    <Box>
      <SettlementDetailContextHeader
        title={SETTLEMENT_CANCELLED_DOCUMENTS_TITLE}
        settlement={settlement}
        actions={actions}
      />

      <Box display="flex" justifyContent="flex-end" mb={2}>
        <SearchInput
          value={search}
          onChange={handleSearchChange}
          onEnter={handleSearchEnter}
          onClear={handleClearSearch}
          placeholder={SETTLEMENT_CANCELLED_DOCUMENTS_SEARCH_PLACEHOLDER}
        />
      </Box>

      <Paper elevation={0} sx={{ overflow: 'hidden' }}>
        <Table hover responsive>
          <thead className="table-header-gray-mui">
            <tr>
              {SETTLEMENT_CANCELLED_DOCUMENTS_TABLE_HEADERS.map((header) => (
                <th
                  key={header}
                  className={header === 'TOTAL' ? 'td-number-align-right' : undefined}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length > 0 ? (
              rows.map((model, index) => (
                <tr key={model.uuid || `${model.child_document_reference}-${index}`}>
                  <td className="td-text-limited">
                    {getTimestampFromDateTime(model?.date_of_charge)}
                  </td>
                  <td className="td-text-limited">{model?.client_uid}</td>
                  <td className="td-text-limited">{model?.client_name}</td>
                  <td className="td-text-limited">{model?.child_document_reference}</td>
                  <td className="td-text-limited">
                    {parseDocumentType(model?.child_document_type)}
                  </td>
                  <td className="td-text-limited">{SETTLEMENT_CANCELLED_DOCUMENTS_STATUS_LABEL}</td>
                  <td className="td-text-limited td-number-align-right">
                    {formatMoney(Number(model?.child_document_total))}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7">{SETTLEMENT_CANCELLED_DOCUMENTS_EMPTY_STATE}</td>
              </tr>
            )}
          </tbody>
        </Table>
      </Paper>
    </Box>
  )
}
